import text_static from './text_static.vue';
import text_input from './text_input.vue';
import number_input from './number_input.vue';
import dropdown from './dropdown.vue';
import popup_picker from './popup_picker.vue';
import multiselect from './multiselect.vue';
import datetime from './datetime/datetime.vue';
import flag from './flag.vue';
import file_upload from './file_upload.vue';
import wysiwyg from './wysiwyg/wysiwyg.vue';
import hook_init from './hook_init.vue';
import row_access from './row_access.vue';
import mailing_init from './mailing_init.vue';
import user_data from './user_data.vue';
import radio_group from './radio_group.vue';
import special_controls from './special_controls/special_controls.vue';
import dropdown_query from './dropdown_query.vue';
import dropdown_page from './dropdown_page.vue';
import dropdown_suggester from './dropdown_suggester.vue';
import map_geocoder from './map_geocoder.vue';
import color_picker from './color_picker.vue';
import dropdown_address from './dropdown_address.vue';
import geo_single from './geo/geo_single.vue'; // geo_multi - в special_controls

// имена импортов являются ключами в метаданных (ctrlCode)
// а порядок в экспорте определяет порядок в выпадушке в редакторе метаданных АРМ

export default {
	text_static,
	text_input,
	number_input,
	dropdown,
	popup_picker,
	multiselect,
	datetime,
	flag,
	file_upload,
	wysiwyg,
	user_data,
	radio_group,
	special_controls,
	dropdown_query,
	dropdown_suggester,
	dropdown_page,
	dropdown_address,
	map_geocoder,
	geo_single,
	color_picker,
	hook_init,
	row_access,
	mailing_init,
};
